module.exports = __webpack_public_path__ + "img/list.5a41e6b4.svg";